export const ERP_COUNTRIES = [
  {
    label: 'Colombia',
    value: 'CO'
  }
]
